import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row, Form } from 'reactstrap'
import _ from 'lodash'

const ATTACHMENTS = [
  { id: 'welder_certificates', label: 'Welder Certificates' },
  { id: 'wps_documents', label: 'WPS' },
  { id: 'inspection_reports', label: 'NDT Inspection Reports' },
  { id: 'welder_list', label: 'Assign Welders (table)' },
  { id: 'wps_list', label: 'Assign WPS (table)' }
]

class Step3ReportSettings extends Component {
  static propTypes = {
    versions: PropTypes.array.isRequired,
    version: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    selected_exclusions: PropTypes.array.isRequired,
    selected_attachments: PropTypes.array.isRequired,
    onFormatChange: PropTypes.func.isRequired,
    onSelectedChange: PropTypes.func.isRequired
  }

  render() {
    const {
      selected_exclusions, selected_attachments, versions, version, format,
      onFormatChange, onSelectedChange
    } = this.props

    const onlyAttachments = selected_exclusions.includes('only_selected_attachments')
    const mergePdf = selected_exclusions.includes('merge_pdf')

    return (
      <Form>
        <Row>
          <Col md="12">
            <h6>Choose report format:</h6>
            <div className="raportBox">
              {_.find(versions, o => o.value === version).formats.map((formatOption, i) => (
                <div key={i} style={{display: 'flex', alignItems: 'flex-start', marginBottom: '5px'}}>
                  <input type="radio" id={`format_${i}`} name="format" value={formatOption.value}
                    onChange={onFormatChange}
                    checked={format === formatOption.value}
                    style={{marginTop: '5px', marginRight: '8px'}}
                  />
                  <label htmlFor={`format_${i}`} style={{margin: 0, cursor: 'pointer'}}>{formatOption.name}</label>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        <Row style={{marginTop: '20px'}}>
          <Col md="12">
            <h6>Attachments:</h6>
            <div className="raportBox">
              {ATTACHMENTS.map(({ id, label }) => (
                <div key={id} style={{display: 'flex', alignItems: 'flex-start', marginBottom: '5px'}}>
                  <input
                    type="checkbox"
                    id={id}
                    value={id}
                    onChange={(e) => onSelectedChange(e.target.value, 'selected_attachments')}
                    checked={selected_attachments.includes(id)}
                    style={{marginTop: '5px', marginRight: '8px'}}
                  />
                  <label htmlFor={id} style={{margin: 0, cursor: 'pointer'}}>{label}</label>
                </div>
              ))}

              <div style={{marginTop: '10px', borderTop: '1px solid #eee', paddingTop: '10px'}}>
                <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '5px'}}>
                  <input
                    type="checkbox"
                    id="only_selected_attachments"
                    value="only_selected_attachments"
                    onChange={(e) => onSelectedChange(e.target.value, 'selected_exclusions')}
                    checked={onlyAttachments}
                    style={{marginTop: '5px', marginRight: '8px'}}
                  />
                  <label htmlFor="only_selected_attachments" style={{margin: 0, cursor: 'pointer'}}>Generate only attachments (no report table)</label>
                </div>

                {format === 'pdf' && (
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <input
                      type="checkbox"
                      id="merge_pdf"
                      value="merge_pdf"
                      onChange={(e) => onSelectedChange(e.target.value, 'selected_exclusions')}
                      checked={mergePdf}
                      style={{marginTop: '5px', marginRight: '8px'}}
                    />
                    <label htmlFor="merge_pdf" style={{margin: 0, cursor: 'pointer'}}>Merge into one PDF file</label>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Step3ReportSettings



// WEBPACK FOOTER //
// ./src/components/FinalReport/Step3ReportSettings.js